import { countAppliedFilters } from "../../filters-redesign/js/global";
/**
 * Component example
    <div class="to-remove">
        <input type="date" name="party" class="fbjs-date-from" data-fbjs-variable-name="webinarsEvents" data-fbjs-narrowing-variable-name="fbStartDate">
        <input type="date" name="party" class="fbjs-date-to" data-fbjs-variable-name="webinarsEvents" data-fbjs-narrowing-variable-name="fbEndDate">
    </div>

* data-fbjs-variable-name -  name of object with fbjs
* data-fbjs-narrowing-variable-name - name of numeric meta from funnelback
*/

export const fbjsDateNarrowing = () => {
    const dateFromSelector = document.querySelector(".fbjs-date-from"),
        dateToSelector = document.querySelector(".fbjs-date-to");

    /**
     *
     * @param {string} target  - event.target
     * @param {string} metadata - here ge_fbdate or le_fbdate.
     * We are using funnelback numeric meta "fbdate" to narrow results,
     * to see more about this, look here:
     * https://docs.squiz.net/funnelback/archive/15.24/customise/metadata-customisation/metadata-class-types.html
     */
    const dateSwitcher = (target, metadata) => {
        let dataValue = target.value || "",
            fbjsVariableName = target.getAttribute("data-fbjs-variable-name");
        if (dataValue) {
            dataValue = dataValue.replace(/-/g, "");
            window[fbjsVariableName].search.additionalFBParams[metadata] =
                dataValue;
            window[fbjsVariableName].doSearch(true, true);
        } else {
            if (window[fbjsVariableName].search.additionalFBParams[metadata]) {
                delete window[fbjsVariableName].search.additionalFBParams[
                    metadata
                ];
                window[fbjsVariableName].doSearch(true, true);
            }
        }
    };
    const changeDate = (dateToChange) => {
        const monthArray = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ],
            splitedDate = dateToChange.split("-");
        return `${splitedDate[2]} ${monthArray[Number(splitedDate[1]) - 1]} ${
            splitedDate[0]
        }`;
    };
    const dateValidationRegex =
        /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
    const removeReadonlyInputOverlay = (e) => {
        const targetInput =
            e.target.parentNode.querySelector('input[type="date"]') || null;
        e.target
            .closest(".date-picker-container")
            .classList.remove("type-changed");
        targetInput.setAttribute("type", "text");
        targetInput.blur();

        if (targetInput) {
            targetInput.value = "";
            targetInput.removeAttribute("readonly");
            targetInput.setAttribute("tabIndex", "0");
            e.target.parentNode.replaceWith(...e.target.parentNode.childNodes);
            e.target.remove();
            // targetInput.focus();
        }
    };
    const switchInputTypeOnFocus = () => {
        const dateFromText =
            document.querySelector('.fbjs-date-from[type="text"]') || null;
        const dateToText =
            document.querySelector('.fbjs-date-to[type="text"]') || null;
        if (dateFromText && dateToText) {
            dateFromText.addEventListener("focus", function (e) {
                e.target.setAttribute("type", "date");
                e.target.showPicker();
            });
            dateToText.addEventListener("focus", function (e) {
                e.target.setAttribute("type", "date");
                e.target.showPicker();
            });

            dateFromText.addEventListener("input", async function (e) {
                e.target.parentNode.classList.add("type-changed");
            });
            dateToText.addEventListener("input", async function (e) {
                e.target.parentNode.classList.add("type-changed");
            });
        }
    };
    switchInputTypeOnFocus();
    const handleReadonlyInput = (inputSelector, validationRegex) => {
        inputSelector.addEventListener("change", async (e) => {
            const attribute = e.target.getAttribute(
                "data-fbjs-narrowing-variable-name"
            );
            const target = e.currentTarget;
            if (e.target.validity.badInput) {
                inputSelector.classList.add("input-error");
            } else {
                inputSelector.classList.contains("input-error") &&
                    inputSelector.classList.remove("input-error");
                if (inputSelector.value === "") {
                    inputSelector.setAttribute("type", "text");
                    inputSelector.parentNode.classList.remove("type-changed");
                }
            }
            if (validationRegex.test(e.target.value)) {
                e.target.setAttribute("readonly", true);
                const dateWrapper = document.createElement("div");
                const dateInputParent = inputSelector.parentNode;
                const dateOverlay = document.createElement("span");
                dateOverlay.classList.add("date-filled-static");
                dateWrapper.classList.add("date-input-wrapper");
                dateOverlay.setAttribute("tabIndex", "0");
                e.target.setAttribute("tabIndex", "-1");
                dateInputParent.insertBefore(dateWrapper, inputSelector);
                dateWrapper.appendChild(inputSelector);
                dateWrapper.appendChild(dateOverlay);
                dateOverlay.innerText = changeDate(e.target.value);
                await new Promise(() => {
                    inputSelector.parentNode.addEventListener("click", (e) => {
                        if (e.target.classList.contains("date-filled-static")) {
                            removeReadonlyInputOverlay(e);
                            countAppliedFilters();
                            if (target.getAttribute("placeholder") === "To") {
                                dateSwitcher(target, "le_" + attribute);
                            } else {
                                dateSwitcher(target, "ge_" + attribute);
                            }
                        }
                    });
                    inputSelector.parentNode.addEventListener(
                        "keydown",
                        (e) => {
                            if (
                                e.target.classList.contains(
                                    "date-filled-static"
                                )
                            ) {
                                e.keyCode === 9 || e.keyCode === 16
                                    ? null
                                    : e.preventDefault();
                                if (e.keyCode === 32 || e.keyCode === 13) {
                                    removeReadonlyInputOverlay(e);
                                }
                            }
                        }
                    );
                });
            }
        });
    };

    const urlParams = new URLSearchParams(window.location.href);
    let dateFrom = urlParams.get("dateFrom");
    let dateTo = urlParams.get("dateTo");
    if (dateFrom != null && dateTo != null) {
        dateFromSelector.focus();
        dateFromSelector.value = dateFrom;
        const narrowingVariableFrom = dateFromSelector.getAttribute(
            "data-fbjs-narrowing-variable-name"
        );
        dateSwitcher(dateFromSelector, `ge_${narrowingVariableFrom}`);

        handleReadonlyInput(dateFromSelector, dateValidationRegex);
        dateFromSelector.blur();

        dateToSelector.focus();
        dateToSelector.value = dateTo;
        const narrowingVariableTo = dateToSelector.getAttribute(
            "data-fbjs-narrowing-variable-name"
        );
        dateSwitcher(dateToSelector, `le_${narrowingVariableTo}`);

        handleReadonlyInput(dateToSelector, dateValidationRegex);
        dateToSelector.blur();
    }

    if (dateFromSelector) {
        dateFromSelector.addEventListener("input", function (e) {
            const narrowingVariable = dateFromSelector.getAttribute(
                "data-fbjs-narrowing-variable-name"
            );
            dateSwitcher(e.currentTarget, `ge_${narrowingVariable}`);
        });
        handleReadonlyInput(dateFromSelector, dateValidationRegex);
    }

    if (dateToSelector) {
        dateToSelector.addEventListener("input", function (e) {
            const narrowingVariable = dateFromSelector.getAttribute(
                "data-fbjs-narrowing-variable-name"
            );
            dateSwitcher(e.currentTarget, `le_${narrowingVariable}`);
        });
        handleReadonlyInput(dateToSelector, dateValidationRegex);
    }
};
